export interface INrrdFileHeader {
  dimension: number;
  encoding: string;
  endian: string;
  extra: { comments: string[]; stride: number[]; min: number; max: number };
  kinds: string[];
  sizes: number[];
  space: string;
  'space dimension': number;
  'space directions': number[][];
  'space origin': number[];
  type: string;
}
